import { useMemo } from 'react';

import { growerProtocolsConfigService } from '../../../../../services/growerProtocolsConfig.service';
import { createApiSlice } from '../../../utils/createApiSlice';

const addGrowerActivitySlice = createApiSlice({
  reducerPath: ['gff', 'growers', 'protocols', 'addGrowerActivity'],
  apiFunction: growerProtocolsConfigService.addActivityV2,
  apiArgumentsFn: ({ growerId, bundleId, protocolId, activity }) => [
    growerId,
    bundleId,
    protocolId,
    activity
  ]
});

const { actions, useApiSelectors } = addGrowerActivitySlice;

export const addGrowerActivityActions = actions;

export const useAddGrowerActivitySelectors = () => {
  const { inProgress, success, errorMessage, response, updatedAt } =
    useApiSelectors();

  return useMemo(
    () => ({ inProgress, success, errorMessage, response, updatedAt }),
    [errorMessage, inProgress, response, success, updatedAt]
  );
};

export default addGrowerActivitySlice;
